export default __webpack_public_path__ + "static/media/icon-chat.e238539d.png";